module.exports = __webpack_public_path__ + "img/small-mytarget.fc1e2d02.svg";